import { ButtonVariant } from '../Components/Button';
import { MedicationType } from '../Contracts/MedicationModels';
import { capitalizeFirstLetter } from '../Shared/StringUtilities';
export function buttonVariantColour(selected, expired, aboutToExpire) {
    if (selected) {
        if (expired) {
            return ButtonVariant.danger;
        }
        else if (aboutToExpire) {
            return ButtonVariant.warning;
        }
    }
    return ButtonVariant.primary;
}
export function isMedicationsSummary(thing) {
    return thing.productPack !== undefined;
}
export function isProductPackSearchResult(thing) {
    return thing.name !== undefined;
}
export var calculateCourseInstructions = function (row) {
    var _a, _b;
    var dosageInstructions = (_a = row.dosageInstructions) !== null && _a !== void 0 ? _a : '';
    var orderInstructions = (_b = row.orderInstructions) !== null && _b !== void 0 ? _b : '';
    if (row.type === MedicationType.MedicationOrder ||
        row.type === MedicationType.EnrmcScript ||
        row.type === MedicationType.ComplementaryTherapyOrder) {
        return capitalizeFirstLetter(orderInstructions);
    }
    return capitalizeFirstLetter(dosageInstructions);
};
